import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Constants } from '@app/constants';
import { TelephonyProvider } from './telephony.provider';
import { Subscription } from 'rxjs';
import { SignalrService } from '@app/core/signalr.service';
import { RealTimeEvents } from '@app/core/signalr.events';
import { ToastService } from '../../services/toast/toast.service';
import { Router } from '@angular/router';
import moment from 'moment';
import { AppConfigurationService } from '../../services/app.configuration.service';

@Injectable({ providedIn: 'root' })
export class TelephonyStateService implements OnDestroy, OnInit {
  subscriptions = new Array<Subscription>();
  onCall: boolean = false;
  onConsultancy: boolean = false;
  onConference: boolean = false;
  isMuted: boolean = false;
  onHold: boolean = false;
  onWrap: boolean = false;
  isCallEnded: boolean = true;
  isCallDisposed: boolean = true;
  onReservationReceived: boolean = false;
  isThirdPartyConnected: boolean = false;
  isCustomerConnected: boolean = true;
  task: any;
  btn: string = '';
  tfn: string = '';
  callSid: string = '';
  campaignCode: string = '';
  onToggle: boolean = false;
  lastCallDialedFromUrl = {
    url: '',
    queryParam: {},
  };
  currentTime: moment.Moment = moment().tz('America/New_York');
  outboundCallRestriction: any = {};
  voiceStatus: boolean = false;
  voiceRegistered: boolean = false;
  cancelThirdParty: boolean = false;
  insightsVoice: any = {
    voice: false,
    registered: false
  }
  tfnCampaignCode = '';
  constructor(
    public telephony: TelephonyProvider,
    private signalRService: SignalrService,
    private toastService: ToastService,
    private router: Router,
    private appConfig: AppConfigurationService
  ) {
    this.subscriptions.push(
      this.telephony.voice.events.subscribe((event) => {
        switch (event.type) {
          case 'Call':
            switch (event.name) {
              case 'accept':
                console.log(new Date().toLocaleString() + '  ➤  telephony state service => call accept');
                const { campaignCode, tfnCampaignCode, btn, tfn, callSid } = event.data;
                this.onCall = true;
                this.isCallEnded = false;
                this.onReservationReceived = false;
                this.campaignCode = campaignCode;
                this.btn = btn;
                this.tfn = tfn;
                this.callSid = callSid;
                this.isCustomerConnected = true;
                this.tfnCampaignCode = tfnCampaignCode;
                break;
              case 'disconnect':
                this.onCall = true;
                this.isCallEnded = true;
                this.isCallDisposed = false;
                break;
              case 'cancel':
                this.onCall = true;
                this.isCallEnded = true;
                this.isCallDisposed = false;
                break;
              case 'dispose':
                this.isCallDisposed = true;
                this.onCall = false;
                this.onConference = false;
                this.onConsultancy = false;
                this.isMuted = false;
                this.onHold = false;
                this.isThirdPartyConnected = false;
                this.isCustomerConnected = false;
                this.onReservationReceived = false;
                this.campaignCode = '';
                this.btn = '';
                this.tfn = '';
                this.callSid = '';
                this.onToggle = false;
                this.cancelThirdParty = false;                  
                break;
              case 'mute':
                this.isMuted = !this.isMuted;
                break;
              case 'callsid':
                this.callSid = event.data;
                break;
              case 'oncall':
                this.onCall = true;
                break;
            }
            break;
          case 'Consult':
            switch (event.name) {
              case 'failed':
                this.onConsultancy = false;
                this.isThirdPartyConnected = false;
                this.isCustomerConnected = true;
                break;
              case 'completed':
                this.onConsultancy = true;
                this.onConference = false;
                this.isThirdPartyConnected = true;
                this.isCustomerConnected = false;
                this.cancelThirdParty = true;
                break;
            }
            break;
          case 'Conference':
            switch (event.name) {
              case 'failed':
                this.onConference = false;
                break;
              case 'completed':
                this.onConference = true;
                this.onConsultancy = false;
                this.isThirdPartyConnected = true;
                this.isCustomerConnected = true;
                this.onToggle = true;
                this.cancelThirdParty = true;
                break;
            }
            break;
          case 'Cancel':
            switch (event.name) {
              case 'completed':
                this.onConference = false;
                this.onConsultancy = false;
                this.isThirdPartyConnected = false;
                this.isCustomerConnected = true;
                this.onToggle = false;
                this.cancelThirdParty = false;
                break;
              case 'third-party-bridge':
                this.onConference = false;
                this.onConsultancy = false;
                this.isThirdPartyConnected = true;
                this.isCustomerConnected = false;
                this.onToggle = false;
                this.cancelThirdParty = false;
                break;
            }
            break;
          case 'Hold':
            switch (event.name) {
              case 'completed':
                this.onHold = !this.onHold;
                break;
            }
            break;
          case 'Toggle':
            switch (event.name) {
              case 'completed':
                if (this.onConference) {
                  if (this.isThirdPartyConnected && this.isCustomerConnected) {
                    this.isCustomerConnected = false;
                  } else if (this.isThirdPartyConnected && !this.isCustomerConnected) {
                    this.isThirdPartyConnected = false;
                    this.isCustomerConnected = true;
                  } else if (!this.isThirdPartyConnected && this.isCustomerConnected) {
                    this.isThirdPartyConnected = true;
                    this.isCustomerConnected = false;
                  }
                }
                else {
                  this.isThirdPartyConnected = !this.isThirdPartyConnected;
                  this.isCustomerConnected = !this.isCustomerConnected;
                }
                this.onConference = false;
                this.onConsultancy = true;
                this.cancelThirdParty = true;
                this.onToggle = event.data;
                break;
            }
            break;
          case 'Reservation':
            switch (event.name) {
              case 'created':
                this.onReservationReceived = true;
                break;
              case 'accepted':
                this.onReservationReceived = false;
                this.task = event.data;
                break;
              case 'rejected':
              case 'timeout':
              case 'canceled':
              case 'rescinded':
              case 'error':
              case 'false':
                this.onReservationReceived = false;
                break;
            }
            break;
          case "Voice":
            switch (event.name) {
              case "status":
                this.voiceStatus = event.data;
                if (!this.voiceRegistered) {
                  this.voiceRegistered = true;
                }
                break;
              case 'insightsVoiceStatus':
                this.insightsVoice.voice = event.data;
                if (!this.insightsVoice.registered) {
                  this.insightsVoice.registered = true;
                }
                break;
            }
            break;
          case "Transfer":
            switch (event.name) {
              case "completed":
                this.cancelThirdParty = false;
                break;
            }
            break;
        }
      })
    );
    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.CallAbandoned).subscribe((callAbandoned: any) => {
        this.telephony.voice.events.next({ type: 'Call', name: 'abandoned', data: callAbandoned.callSid });
      })
    );
    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.OutboundCallHangup).subscribe((outboundCallHangup: any) => {
        console.log(new Date().toLocaleString() + '  ➤  OutboundCallHangup Signal R Events ==> ', outboundCallHangup);
        this.telephony.voice.outboundCallHangup(
          null,
          outboundCallHangup.agentIdentity,
          outboundCallHangup.errorMessage
        );
      })
    );
    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.ThirdPartyHangup).subscribe((thirdPartyHangup: any) => {
        this.toastService.info('Third party has left the call');
        console.log(new Date().toLocaleString() + '  ➤  thirdPartyHangup Signal R Events telephony state ==> ', thirdPartyHangup);
        this.onConsultancy = false;
        this.onConference = false;
        this.isThirdPartyConnected = false;
        this.isCustomerConnected = true;
        this.telephony.voice.events.next({ type: 'Cancel', name: 'completed', data: '' });
      })
    );
  }
  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  //* Using For Mock Calls for QA/UX
  public onCallStart(): void {
    this.onCall = true;
    this.isCallEnded = false;
    this.isCallDisposed = false;
    this.campaignCode = 'K02';
    this.btn = '+17029131466';
    this.tfn = '+18663957108';
    this.callSid = '234234234jk23bn4kj';
  }
  public onCallEnd(): void {
    this.isCallEnded = true;
    this.onCall = false;
    this.campaignCode = '';
    this.btn = '';
    this.tfn = '';
    this.callSid = '';
  }
  public onCallDisposed(): void {
    this.isCallDisposed = true;
  }
  public routeToLastDialedTarget() {
    if (this.lastCallDialedFromUrl.url)
      this.router.navigate([this.lastCallDialedFromUrl.url], {
        queryParams: this.lastCallDialedFromUrl.queryParam,
      });
    this.lastCallDialedFromUrl = { url: '', queryParam: {} };
  }
  public isOutboundCallRestriction(campaign: string): boolean {

    // get all configs
    const restrictions = this.appConfig.getByIdentifier('OutboundCallResitriction')?.Fields;

    let isRestricted: boolean = false;

    if (!restrictions || restrictions.length === 0) {
      return false;
    }

    // find config for current campaign
    const restrictionConfig = restrictions.find((x: any) =>
      x.campaigns?.includes(campaign)
    );

    if (!restrictionConfig) {
      return false;
    }

    // check if restriction enabled
    if (restrictionConfig.is_enable) {

      // Get current time
      this.currentTime = this.getCurrentTime();

      const startTime = moment.tz(
        restrictionConfig.restricted_start_time,
        restrictionConfig.time_format,
        restrictionConfig.time_zone
      );

      const endTime = moment.tz(
        restrictionConfig.restricted_end_time,
        restrictionConfig.time_format,
        restrictionConfig.time_zone
      );

      const isRestrictedTime = this.isWithinRestrictedHours(
        startTime,
        endTime,
        restrictionConfig.time_zone
      );

      if (isRestrictedTime) {
        isRestricted = true;
        this.toastService.warning(
          `Can't Make Outbound Call between ${restrictionConfig.restricted_start_time} to ${restrictionConfig.restricted_end_time}`
        );
      }
    }

    return isRestricted;
  }

  private getCurrentTime(): moment.Moment {
    // Retrieve or initialize the current time in the specific timezone
    return moment().tz('America/New_York');
  }

  private isWithinRestrictedHours(
    startTime: moment.Moment,
    endTime: moment.Moment,
    timeZone: string
  ): boolean {
    const currentHour = moment.tz(timeZone).hour();
    const startHour = startTime.hour();
    const endHour = endTime.hour();
    // Overnight range (e.g., 21 → 9)
    if (endHour < startHour) {
      return currentHour >= startHour || currentHour < endHour;
    }
    // Normal range (e.g., 9 → 17)
    return currentHour >= startHour && currentHour < endHour;
  }

  isOperationAllowed(
    tfn: string,
    operation: string
  ): boolean {

    let config = this.appConfig.getByIdentifier('CallOperationResitriction').Fields;
    // If feature is disabled → allow all
    if (!config?.is_enable) {
      return true;
    }

    const settings = config.settings || [];

    // Find TFN config
    const tfnConfig = settings.find((s: any) => tfn.includes(s.tfn));
    if (!tfnConfig) {
      return true; // no rule → allow
    }

    // Check operation
    if (!tfnConfig.operation?.includes(operation)) {
      return true; // operation not restricted
    }

    const date = this.getCurrentTime();

    const currentDay = date.get('day');   // 0–6
    const currentHour = date.get('hour'); // 0–23

    // Find day rule
    const dayRule = tfnConfig.hours?.find(
      (h: any) => h.day === currentDay
    );

    if (!dayRule) {
      return false; // restricted & no time rule found
    }

    const start = dayRule.start;
    const end = dayRule.end;

    // Handle full-day case (0–24)
    if (start === 0 && end === 24) {
      return true;
    }

    return currentHour >= start && currentHour < end;
  }
}
